import './Menu.css'
import React, { useState } from 'react'
import Sidebar from '../../Components/SideBar/index'
import ScrollToTop from '../../Components/ScrollToTop'
import Index2 from '../../Components/Navbar2/index2'
import Footer from '../../Components/Footer/Footer'
import InfoSection3 from '../../Components/Infosection3/Index3'
import { homeObjOne3 } from '../../Components/Infosection3/Data3'

const MenuSka = () => {
  const [isOpen, setIsOpen] = useState(false)
                    
    const toggle = () => {
    setIsOpen(!isOpen)
    }
  return (
    <>
      <ScrollToTop />
      <div className='HeroContainer_menu'>
         <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='Hero_menu'>
         <Index2 toggle={toggle}/>
        </div>
      </div>
      <InfoSection3 {...homeObjOne3}/>
      <div className='menu_con'>
        <div className='menu_title'>
          Vår Meny
        </div>
        <div className='pris'>
          För mer info kontakta gärna 
          <br />
          076 413 08 53
          <br />
          cateringbyprestig@gmail.com
        </div>
      </div>
      <br />
       <br /><br />
      <div className='menu'>
        <div className='menu_pic'>
          <div className='grid-container'>
                  <div className='card_con'>
                    <div className='wrapper'>
                      <br /><br />
                        <div className='card_area'>
                          <div className='card'>
                            <div className='meny_title'>
                              KALLA DELIKATESSER 
                            </div><br /><br />
                            <div className='menu_mat'>
                              Kallrökt lax med citron, dill & hovmästarsås.
                              <br /><br />
                              Gravad lax med klassisk senaps- och dillsås.
                              <br /><br />
                              Handpillade räkor med citron & dill.
                              <br /><br />
                              Matjessill med gräddfil, rödlök & gräslök.
                              <br /><br />
                              Klassisk senapssill.
                              <br /><br />
                              Inlagd sill med äpple & dill.
                              <br /><br />
                              Ägghalvor med handskalade räkor, majonnäs & dill.
                              <br /><br />
                              Skivad rostbiff med rostad lök & pepparrotskräm.
                              <br /><br />
                              Kallskuret med nordiska örter
                            </div>
                            </div>
                            <div className='card'>
                              <div className='meny_title'>
                                NORDISKA SPECIALITETER
                              </div><br /><br />
                              <div className='menu_mat'>
                                Dillkokt färskpotatis.
                                <br /><br />
                                Västerbottensostpaj.
                                <br /><br />
                                Rödbetssallad med äpple.
                                <br /><br />
                                Krämig gurksallad med dill.
                                <br /><br />
                                Fänkålssallad med äpple & citron.
                                <br /><br />
                                Grönsallad med nordiska örter.
                                <br /><br />
                                Picklade säsongsgrönsaker
                              </div> 
                            </div>              
                            <div className='card'>
                              <div className='meny_title'>
                                VARMA RÄTTER
                              </div><br /><br />
                            <div className='menu_mat'>
                              Ugnsbakad lax med citron & dill.
                              <br /><br />
                              Örtbakad kycklingfilé med krämig pepparsås
                              <br /><br />
                              Svenska köttbullar med gräddsås & lingon.
                              <br /><br />
                              Rostad potatis med rosmarin.
                              <br /><br />
                              Ugnsrostade nordiska rotfrukter.
                              <br /><br />
                              Gröna bönor med färska örter.
                            </div>
                            </div>
                            <div className='card'>
                            <div className='meny_title'>
                              NORDISK OSTBRICKA
                                </div><br /><br />
                                <div className='menu_mat'>
                                  Västerbottensost
                                  <br /><br />
                                  Prästost
                                  <br /><br />
                                  Svensk blåmögelost
                                  <br /><br />
                                  Knäckebröd
                                  <br /><br />
                                  Fikonmarmelad
                                  <br /><br />
                                  Vindruvor & päron
                                </div>
                                </div>
                                <div className='card'>
                              <div className='meny_title'>
                                   BRÖD & TILLBEHÖR
                                </div><br /><br />
                                <div className='menu_mat'>
                                  Nybakat surdegsbröd
                                  <br /><br />
                                  Svenskt knäckebröd
                                  <br /><br />
                                  Kavring
                                  <br /><br />
                                  Vispat smör
                                  <br /><br />
                                  Färskost med nordiska örter
                                  <br /><br />
                                </div>
                                </div>
                                <div className='card'>
                              <div className='meny_title'>
                                NORDISKA DESSERTER
                        </div><br /><br />
                        <div className='menu_mat'>
                          Kladdkaka med lättvispad grädde.
                          <br /><br />
                          Vaniljpannacotta med hjortron.
                          <br /><br />
                          Svensk äppelkaka med vaniljkräm.
                          <br /><br />
                          Små chokladpraliner.
                        </div>
                    </div>
                  </div>             
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </>
  )
}

export default MenuSka